import type { ButtonHTMLAttributes, HTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import { Radio } from 'lucide-react';

export function FlexCastMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="fc-mark" aria-label="FlexCast">
      <span className="fc-mark__icon">
        <Radio size={compact ? 18 : 22} strokeWidth={2.4} />
      </span>
      {!compact && <span>FlexCast</span>}
    </div>
  );
}

export function Button({
  tone = 'primary',
  className = '',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  tone?: 'primary' | 'secondary' | 'danger' | 'ghost';
}) {
  return <button className={`fc-button fc-button--${tone} ${className}`} {...props} />;
}

export function Card({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={`fc-card ${className}`} {...props} />;
}

export function Badge({
  tone = 'neutral',
  children,
}: PropsWithChildren<{ tone?: 'neutral' | 'success' | 'warning' | 'danger' | 'live' }>) {
  return <span className={`fc-badge fc-badge--${tone}`}>{children}</span>;
}

export function Metric({
  label,
  value,
  detail,
  icon,
}: {
  label: string;
  value: ReactNode;
  detail?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <Card className="fc-metric">
      <div className="fc-metric__top">
        <span>{label}</span>
        {icon}
      </div>
      <strong>{value}</strong>
      {detail && <small>{detail}</small>}
    </Card>
  );
}

export function Spinner({ label = 'Loading' }: { label?: string }) {
  return <span className="fc-spinner" role="status" aria-label={label} />;
}

export function EmptyState({
  icon,
  title,
  copy,
}: {
  icon: ReactNode;
  title: string;
  copy: string;
}) {
  return (
    <div className="fc-empty">
      <span>{icon}</span>
      <h3>{title}</h3>
      <p>{copy}</p>
    </div>
  );
}
